import React from "react";
import UsersToday from "../components/pages/Dashboard/UsersToday";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";

const UsersTodayLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{margin: "70px 0px 0px 200px", width: "100%"}}>
        <UsersToday />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default UsersTodayLayout;